const INITIAL_STATE = {
  data: {},
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  GET_COMPANY_SUCCESS: 'company/GET_COMPANY_SUCCESS',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_COMPANY_SUCCESS:
      return { ...state, data: action.payload };
    default:
      return state;
  }
}

/**
 * Helpers
 */
// eslint-disable-next-line max-len
export const getCompany = (state) => {
  if (state.company.data && state.company.data.source) {
    return state.company.data.source;
  }
  return {};
};

export const getCompanyObject = state => state.company.data;

export const getCompanyId = (state) => {
  if (state.company.data && state.company.data.id) {
    return state.company.data.id;
  }
  return 1;// triider
};

/**
 * Actions Creators
 */
export const Creators = {
  getCompanySuccess: payload => ({
    type: Types.GET_COMPANY_SUCCESS,
    payload,
  }),
};
